/**
 * @generated SignedSource<<819ffccfd2d36777334f841cfb64aa5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PanelRecruitFilterEnum = "MATCHED_PANEL" | "RECRUITED_PANEL" | "%future added value";
export type ScreenersRecruitStatusChoices = "F" | "NS" | "P" | "S" | "%future added value";
export type ScreenersRecruitTypeChoices = "EM" | "HP" | "RO" | "WL" | "YP" | "%future added value";
export type RecruitMatchQuery$variables = {
  count: number;
  cursor?: string | null;
  panelFilters?: any | null;
  panelRecruitFilter?: PanelRecruitFilterEnum | null;
  panelSettings?: string | null;
  recruitId?: string | null;
  searchTerm?: string | null;
  studyId: string;
};
export type RecruitMatchQuery$data = {
  readonly viewer: {
    readonly recruit: {
      readonly dbId: string;
      readonly export: {
        readonly " $fragmentSpreads": FragmentRefs<"ExportButton_export">;
      } | null;
      readonly id: string;
      readonly matched: {
        readonly totalCount: number | null;
      } | null;
      readonly name: string | null;
      readonly recruited: {
        readonly totalCount: number | null;
      } | null;
      readonly status: ScreenersRecruitStatusChoices;
      readonly table: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly completedStudiesCount: number | null;
            readonly dId: any | null;
            readonly id: string;
            readonly joined: string | null;
            readonly panelistMembership: {
              readonly latestCompleteScreenerDate: string | null;
              readonly latestCompleteScreenerName: string | null;
              readonly latestRatedParticipant: {
                readonly rating: number;
              } | null;
              readonly latestStudyDate: string | null;
              readonly latestStudyName: string | null;
            } | null;
            readonly person: {
              readonly email: string | null;
              readonly firstName: string | null;
              readonly lastName: string | null;
              readonly panelist: {
                readonly id: string;
              } | null;
              readonly phoneNumber: string | null;
            } | null;
            readonly recruitStatus: string | null;
            readonly recruitedToStudy: boolean | null;
            readonly responses: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly answer: {
                    readonly id: string;
                  } | null;
                  readonly characteristic: {
                    readonly id: string;
                  };
                  readonly row: {
                    readonly id: string;
                    readonly text: string;
                  } | null;
                  readonly textValue: string;
                } | null;
              } | null>;
            };
          } | null;
        } | null>;
        readonly totalCount: number | null;
      } | null;
      readonly type: ScreenersRecruitTypeChoices | null;
    } | null;
    readonly study: {
      readonly tenant: {
        readonly name: string;
      };
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"RecruitMatch_viewer">;
  };
};
export type RecruitMatchQuery = {
  response: RecruitMatchQuery$data;
  variables: RecruitMatchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "panelFilters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "panelRecruitFilter"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "panelSettings"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recruitId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "studyId"
},
v8 = [
  {
    "kind": "Variable",
    "name": "recruitId",
    "variableName": "recruitId"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dbId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v12 = [
  (v11/*: any*/)
],
v13 = {
  "alias": "matched",
  "args": [
    {
      "kind": "Literal",
      "name": "panelRecruitFilter",
      "value": "MATCHED_PANEL"
    }
  ],
  "concreteType": "PanelistConnection",
  "kind": "LinkedField",
  "name": "eligiblePanelists",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": "eligiblePanelists(panelRecruitFilter:\"MATCHED_PANEL\")"
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v15 = {
  "alias": "recruited",
  "args": [
    {
      "kind": "Literal",
      "name": "panelRecruitFilter",
      "value": "RECRUITED_PANEL"
    }
  ],
  "concreteType": "PanelistConnection",
  "kind": "LinkedField",
  "name": "eligiblePanelists",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": "eligiblePanelists(panelRecruitFilter:\"RECRUITED_PANEL\")"
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = {
  "kind": "Variable",
  "name": "panelFilters",
  "variableName": "panelFilters"
},
v18 = {
  "kind": "Variable",
  "name": "panelRecruitFilter",
  "variableName": "panelRecruitFilter"
},
v19 = {
  "kind": "Variable",
  "name": "panelSettings",
  "variableName": "panelSettings"
},
v20 = {
  "kind": "Variable",
  "name": "searchTerm",
  "variableName": "searchTerm"
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedStudiesCount",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v27 = [
  (v9/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "PanelistNode",
  "kind": "LinkedField",
  "name": "panelist",
  "plural": false,
  "selections": (v27/*: any*/),
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestCompleteScreenerName",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestCompleteScreenerDate",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestStudyName",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestStudyDate",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rating",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "joined",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recruitedToStudy",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recruitStatus",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "CharacteristicNode",
  "kind": "LinkedField",
  "name": "characteristic",
  "plural": false,
  "selections": (v27/*: any*/),
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "CharacteristicAnswerNode",
  "kind": "LinkedField",
  "name": "answer",
  "plural": false,
  "selections": (v27/*: any*/),
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "CharacteristicRowNode",
  "kind": "LinkedField",
  "name": "row",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textValue",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v45 = [
  {
    "kind": "Variable",
    "name": "studyId",
    "variableName": "studyId"
  }
],
v46 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RecruitMatchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "RecruitNode",
            "kind": "LinkedField",
            "name": "recruit",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ExportNode",
                "kind": "LinkedField",
                "name": "export",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ExportButton_export"
                  }
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "alias": "table",
                "args": [
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "concreteType": "PanelistConnection",
                "kind": "LinkedField",
                "name": "__RecruitMatch_table_connection",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PanelistEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PanelistNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PersonNode",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v28/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PanelistMembershipNode",
                            "kind": "LinkedField",
                            "name": "panelistMembership",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/),
                              (v30/*: any*/),
                              (v31/*: any*/),
                              (v32/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ParticipantNode",
                                "kind": "LinkedField",
                                "name": "latestRatedParticipant",
                                "plural": false,
                                "selections": [
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharacteristicResponseNodeConnection",
                            "kind": "LinkedField",
                            "name": "responses",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CharacteristicResponseNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CharacteristicResponseNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v37/*: any*/),
                                      (v38/*: any*/),
                                      (v39/*: any*/),
                                      (v40/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v41/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v42/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v43/*: any*/)
                ],
                "storageKey": null
              },
              (v44/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v45/*: any*/),
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TenantNode",
                "kind": "LinkedField",
                "name": "tenant",
                "plural": false,
                "selections": [
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RecruitMatch_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "RecruitMatchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "RecruitNode",
            "kind": "LinkedField",
            "name": "recruit",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ExportNode",
                "kind": "LinkedField",
                "name": "export",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "countCompleted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "countTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sentOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sentTo",
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNode",
                    "kind": "LinkedField",
                    "name": "to",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "alias": "table",
                "args": (v46/*: any*/),
                "concreteType": "PanelistConnection",
                "kind": "LinkedField",
                "name": "eligiblePanelists",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PanelistEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PanelistNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PersonNode",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v28/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PanelistMembershipNode",
                            "kind": "LinkedField",
                            "name": "panelistMembership",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/),
                              (v30/*: any*/),
                              (v31/*: any*/),
                              (v32/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ParticipantNode",
                                "kind": "LinkedField",
                                "name": "latestRatedParticipant",
                                "plural": false,
                                "selections": [
                                  (v33/*: any*/),
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharacteristicResponseNodeConnection",
                            "kind": "LinkedField",
                            "name": "responses",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CharacteristicResponseNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CharacteristicResponseNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v37/*: any*/),
                                      (v38/*: any*/),
                                      (v39/*: any*/),
                                      (v40/*: any*/),
                                      (v9/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v41/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v42/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v43/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "table",
                "args": (v46/*: any*/),
                "filters": [
                  "panelSettings",
                  "panelFilters",
                  "panelRecruitFilter",
                  "searchTerm"
                ],
                "handle": "connection",
                "key": "RecruitMatch_table",
                "kind": "LinkedHandle",
                "name": "eligiblePanelists"
              },
              (v44/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v45/*: any*/),
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TenantNode",
                "kind": "LinkedField",
                "name": "tenant",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isStaff",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TenantNode",
                    "kind": "LinkedField",
                    "name": "tenant",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enablePanelExport",
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2486caae78e042c5cb50d13b46297fbe",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": "count",
          "cursor": "cursor",
          "direction": "forward",
          "path": [
            "viewer",
            "recruit",
            "table"
          ]
        }
      ]
    },
    "name": "RecruitMatchQuery",
    "operationKind": "query",
    "text": "query RecruitMatchQuery(\n  $count: Int!\n  $cursor: String\n  $studyId: String!\n  $panelSettings: String\n  $panelRecruitFilter: PanelRecruitFilterEnum\n  $panelFilters: GenericScalar\n  $recruitId: String\n  $searchTerm: String\n) {\n  viewer {\n    recruit(recruitId: $recruitId) {\n      id\n      dbId\n      export {\n        ...ExportButton_export\n        id\n      }\n      matched: eligiblePanelists(panelRecruitFilter: MATCHED_PANEL) {\n        totalCount\n      }\n      status\n      recruited: eligiblePanelists(panelRecruitFilter: RECRUITED_PANEL) {\n        totalCount\n      }\n      name\n      table: eligiblePanelists(first: $count, after: $cursor, panelSettings: $panelSettings, panelRecruitFilter: $panelRecruitFilter, panelFilters: $panelFilters, searchTerm: $searchTerm) {\n        totalCount\n        edges {\n          node {\n            id\n            dId\n            completedStudiesCount\n            person {\n              firstName\n              lastName\n              email\n              phoneNumber\n              panelist {\n                id\n              }\n              id\n            }\n            panelistMembership {\n              latestCompleteScreenerName\n              latestCompleteScreenerDate\n              latestStudyName\n              latestStudyDate\n              latestRatedParticipant {\n                rating\n                id\n              }\n              id\n            }\n            joined\n            recruitedToStudy\n            recruitStatus\n            responses {\n              edges {\n                node {\n                  characteristic {\n                    id\n                  }\n                  answer {\n                    id\n                  }\n                  row {\n                    id\n                    text\n                  }\n                  textValue\n                  id\n                }\n              }\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      type\n    }\n    study(studyId: $studyId) {\n      tenant {\n        name\n        id\n      }\n      id\n    }\n    ...RecruitMatch_viewer\n  }\n}\n\nfragment ExportButton_export on ExportNode {\n  id\n  countCompleted\n  countTotal\n  sentOn\n  sentTo\n  status\n  to {\n    email\n    id\n  }\n}\n\nfragment RecruitMatch_viewer on Viewer {\n  user {\n    isStaff\n    profile {\n      tenant {\n        enablePanelExport\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "97d2cb4ae43e21d80356f58096da9ed8";

export default node;
